// The key of one rendered item (a table, chart, composite or query) inside its
// tool call. The marker dispatcher stamps every event with a replay-stable
// `id` (`<event>-<tool_use_id>-<n>`); events from before that carry only
// `toolCallId`, so they fall back to `<toolCallId>:<ordinal>`, where the
// ordinal is the item's position among that plugin's items in the tool call.
//
// The chat cards and the Notebook both key items with this one function, so
// "Open in notebook" on a card lands on the Notebook cell with the same key.
export function pluginEventId(data: Record<string, unknown>, ordinalWithinToolCall: number): string | undefined {
  const id = data.id
  if (typeof id === 'string' && id) return id
  const toolCallId = data.toolCallId
  if (typeof toolCallId === 'string' && toolCallId) return `${toolCallId}:${ordinalWithinToolCall}`
  return undefined
}
